import FormModule from '@/plugins/ul/form';

export default FormModule;
